import { lazy } from 'react'
import { FaChalkboardTeacher, FaSchool } from 'react-icons/fa'

import {
  AccountBalance,
  Assignment,
  BadgeRounded,
  Book,
  CalendarMonth,
  Campaign,
  CastForEducation,
  DesignServices,
  Difference,
  Grading,
  Groups,
  History,
  Home,
  HowToReg,
  List,
  ManageAccounts,
  MedicalServices,
  MeetingRoom,
  MenuBook,
  PendingActions,
  QueryStats,
  Schedule,
  School,
  Sports,
  Summarize,
  SupervisedUserCircle,
  TableView,
  UploadFile,
  CrisisAlert,
  Settings,
  FlagCircle,
  LockClock,
  Star,
  EventNote,
  Flag,
  HistoryEdu,
  Group,
  AssignmentTurnedIn,
  AdminPanelSettings,
  PersonSearch,
  NotificationImportant,
  SwitchAccount,
  Insights,
  ReceiptLong,
  FactCheck,
  PunchClock,
  PublishedWithChanges,
  ViewModule,
  ChatBubble,
  Storage,
  Category,
  ListAlt,
  Psychology,
  Grade,
  EmojiObjects,
  SpeakerNotes,
  EmojiEvents,
  TrackChanges,
  Timer,
  TrendingUp,
  Signpost,
} from '@mui/icons-material'
import { t } from 'i18next'

import StudentWorkspacePage from 'pages/protected/StudentWorkspacePage'
import StudentDashboardPage from 'pages/protected/StudentDashboardPage'
import StudentWelcomePage from 'pages/protected/StudentWelcomePage'
import StudentGroupsPage from 'pages/protected/StudentGroupsPage'
import AcademicPeriodCrudPage from 'pages/protected/crud/AcademicPeriodCrudPage'
import AnnouncementCrudPage from 'pages/protected/crud/AnnouncementCrudPage'
import AssignmentCrudPage from 'pages/protected/crud/AssignmentCrudPage'
import AttendanceCrudPage from 'pages/protected/crud/AttendanceCrudPage'
import BehaviorCrudPage from 'pages/protected/crud/BehaviorCrudPage'
import CourseCrudPage from 'pages/protected/crud/CourseCrudPage'
import CourseComponentCrudPage from 'pages/protected/crud/CourseComponentCrudPage'
import SyllabusCrudPage from 'pages/protected/crud/SyllabusCrudPage'
import GradeLevelCrudPage from 'pages/protected/crud/GradeLevelCrudPage'
import GroupCrudPage from 'pages/protected/crud/GroupCrudPage'
import GroupCourseCrudPage from 'pages/protected/crud/GroupCourseCrudPage'
import MedicalRecordCrudPage from 'pages/protected/crud/MedicalRecordCrudPage'
import MeetingCrudPage from 'pages/protected/crud/MeetingCrudPage'
import MeetingReportCrudPage from 'pages/protected/crud/MeetingReportCrudPage'
import PlopReportRecordCrudPage from 'pages/protected/crud/PlopReportRecordCrudPage'
import PlopReportCrudPage from 'pages/protected/crud/PlopReportCrudPage'
import MilestoneCrudPage from 'pages/protected/crud/MilestoneCrudPage'
import ParentCrudPage from 'pages/protected/crud/ParentCrudPage'
import RubricCrudPage from 'pages/protected/crud/RubricCrudPage'
import SessionCrudPage from 'pages/protected/crud/SessionCrudPage'
import StaffCrudPage from 'pages/protected/crud/StaffCrudPage'
import StudentAssignmentCrudPage from 'pages/protected/crud/StudentAssignmentCrudPage'
import StudentCrudPage from 'pages/protected/crud/StudentCrudPage'
import TeacherCrudPage from 'pages/protected/crud/TeacherCrudPage'
import LessonPlanCrudPage from 'pages/protected/crud/LessonPlanCrudPage'
import GradeRiskCriteriaCrudPage from 'pages/protected/crud/GradeRiskCriteriaCrudPage'
import GradeScaleCrudPage from 'pages/protected/crud/GradeScaleCrudPage'
import TimetableCrudPage from 'pages/protected/crud/TimetableCrudPage'
import TeamCrudPage from 'pages/protected/crud/TeamCrudPage'
import SetupEntityPage from 'pages/protected/SetupEntityPage'
import SetupEntityCrudPage from 'pages/protected/crud/SetupEntityCrudPage'
import SetupEntitySettingCrudPage from 'pages/protected/crud/SetupEntitySettingCrudPage'
import CourseSetupPage from 'pages/protected/CourseSetupPage'
import SyllabusSetupPage from 'pages/protected/SyllabusSetupPage'
import AdjustmentCrudPage from 'pages/protected/crud/AdjustmentCrudPage'
import RtiInterventionCrudPage from 'pages/protected/crud/RtiInterventionCrudPage'
import RtiRiskCrudPage from 'pages/protected/crud/RtiRiskCrudPage'
import RtiConcernCrudPage from 'pages/protected/crud/RtiConcernCrudPage'
import RtiStudentPage from 'pages/protected/RtiStudentPage'
import SpecialStudentPage from 'pages/protected/SpecialStudentPage'


import { RoleType } from 'types'
import UnitCrudPage from 'pages/protected/crud/UnitCrudPage'
import CurriculumMapSetupPage from 'pages/protected/CurriculumMapSetupPage'
import CurriculumUnitsPage from 'pages/protected/CurriculumUnitsPage'
import ParentWorkspacePage from 'pages/protected/ParentWorkspacePage'
import ParentProgramsPage from 'pages/protected/ParentProgramsPage'
import TeacherWorkspacePage from 'pages/protected/TeacherWorkspacePage'
import SubmissionPage from 'pages/protected/SubmissionPage'
import TeacherAttendancePage from 'pages/protected/crud/TeacherAttendancePage'
import TeacherBehaviourPage from 'pages/protected/crud/TeacherBehaviourPage'
import TeacherClassroomPage from 'pages/protected/crud/TeacherClassroomPage'
import BenchmarkCrudPage from 'pages/protected/crud/BenchmarkCrudPage'
import KpiEvaluationsPage from 'pages/protected/KpiEvaluationsPage'
import ProgramsSetupPage from 'pages/protected/ProgramsSetupPage'
import BenchmarkTrackerSetupPage from 'pages/protected/BenchmarkTrackerSetupPage'
import KpiTrackerSetupPage from 'pages/protected/KpiTrackerSetupPage'

const DashboardPage = lazy(() => import('pages/protected/DashboardPage'))
const SchoolPage = lazy(() => import('pages/protected/SchoolPage'))
const AcademicPeriodsPage = lazy(() => import('pages/protected/AcademicPeriodsPage'))
const AnnouncementsPage = lazy(() => import('pages/protected/AnnouncementsPage'))
const MilestonesPage = lazy(() => import('pages/protected/MilestonesPage'))
const GradeScalePage = lazy(() => import('pages/protected/GradeScalePage'))
const GradeRiskCriteriaPage = lazy(() => import('pages/protected/GradeRiskCriteriaPage'))
const RiskCriteriaPage = lazy(() => import('pages/protected/RiskCriteriaPage'))
const RubricsPage = lazy(() => import('pages/protected/RubricsPage'))
const AttendancePage = lazy(() => import('pages/protected/AttendancePage'))
const BehaviorPage = lazy(() => import('pages/protected/BehaviorPage'))
const StudentsPage = lazy(() => import('pages/protected/StudentsPage'))
const ParentsPage = lazy(() => import('pages/protected/ParentsPage'))
const TeachersPage = lazy(() => import('pages/protected/TeachersPage'))
const StaffPage = lazy(() => import('pages/protected/StaffPage'))
const MedicalRecordsPage = lazy(() => import('pages/protected/MedicalRecordsPage'))
const CoursesPage = lazy(() => import('pages/protected/CoursesPage'))
const SyllabusPage = lazy(() => import('pages/protected/SyllabusPage'))
const CourseComponentsPage = lazy(() => import('pages/protected/CourseComponentsPage'))
const LessonPlansPage = lazy(() => import('pages/protected/LessonPlansPage'))
const GroupsPage = lazy(() => import('pages/protected/GroupsPage'))
const GroupCoursesPage = lazy(() => import('pages/protected/GroupCoursesPage'))
const AssignmentsPage = lazy(() => import('pages/protected/AssignmentsPage'))
const SubmissionsPage = lazy(() => import('pages/protected/SubmissionsPage'))
const GradebookAssessmentsPage = lazy(() => import('pages/protected/GradebookAssessmentsPage'))
const GradebookPage = lazy(() => import('pages/protected/GradebookPage'))
const GradesPage = lazy(() => import('pages/protected/GradesPage'))
const StudentGradesPage = lazy(() => import('pages/protected/StudentGradesPage'))
const SessionsPage = lazy(() => import('pages/protected/SessionsPage'))
const MeetingsPage = lazy(() => import('pages/protected/MeetingsPage'))
const MeetingReportsPage = lazy(() => import('pages/protected/MeetingReportsPage'))
const PlopReportsPage = lazy(() => import('pages/protected/PlopReportsPage'))
const PlopReportRecordsPage = lazy(() => import('pages/protected/PlopReportRecordsPage'))
const ProgramsPage = lazy(() => import('pages/protected/ProgramsPage'))
const StudentAssignmentsPage = lazy(() => import('pages/protected/StudentAssignmentsPage'))
const SetupPage = lazy(() => import('pages/protected/SetupPage'))
const GoalbankPage = lazy(() => import('pages/protected/GoalbankPage'))
const CurriculumMapsPage = lazy(() => import('pages/protected/CurriculumMapsPage'))
const TimetablesPage = lazy(() => import('pages/protected/TimetablesPage'))
const EarlyWarningsPage = lazy(() => import('pages/protected/EarlyWarningsPage'))
const AdjustmentsPage = lazy(() => import('pages/protected/AdjustmentsPage'))
const TeamsPage = lazy(() => import('pages/protected/TeamsPage'))
const RtiAnnouncementsPage = lazy(() => import('pages/protected/RtiAnnouncementsPage'))
const RtiRisksPage = lazy(() => import('pages/protected/RtiRisksPage'))
const RtiConcernsPage = lazy(() => import('pages/protected/RtiConcernsPage'))
const RtiInterventionsPage = lazy(() => import('pages/protected/RtiInterventionsPage'))
const RtiMeetingsPage = lazy(() => import('pages/protected/RtiMeetingsPage'))
const RtiTeamPage = lazy(() => import('pages/protected/RtiTeamPage'))
const SpecialStudentsPage = lazy(() => import('pages/protected/SpecialStudentsPage'))
const SpecialMeetingsPage = lazy(() => import('pages/protected/SpecialMeetingsPage'))
const SpecialTeamPage = lazy(() => import('pages/protected/SpecialTeamPage'))
const UnauthorizedPage = lazy(() => import('pages/protected/UnauthorizedPage'))

const DomainsPage = lazy(() => import('pages/protected/DomainsPage'))
const ClustersPage = lazy(() => import('pages/protected/ClustersPage'))
const GoalsPage = lazy(() => import('pages/protected/GoalsPage'))
const BenchmarksPage = lazy(() => import('pages/protected/BenchmarksPage'))
const BenchmarkEvaluationsPage = lazy(() => import('pages/protected/BenchmarkEvaluationsPage'))

export interface INavItem {
  icon: JSX.Element
  label: string
  route: string
  nestedRoutes?: string[]
  subRoutes?: string[]
  roles: RoleType[]
  component: JSX.Element
  nestedComponents?: JSX.Element[]
  subComponents?: JSX.Element[]
  skip?: Boolean
  children?: INavItem[]
}

const MCID =   {
          icon: <Storage />,
          label: t('common.mcid'),
          route: null,
          roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
          component: null,
          children: [
            {
              icon: <FlagCircle />,
              label: t('common.goalbank'),
              route: 'goalbank',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher'] as RoleType[],
              component: <GoalbankPage />,
            },
            {
              icon: <Timer />,
              label: t('common.benchmark-tracker'),
              route: 'benchmark-tracker',
              component: <BenchmarkEvaluationsPage />,
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
              subRoutes: ['setup/benchmark-tracker'],
              subComponents: [<BenchmarkTrackerSetupPage />],
            }, 
            {
              icon: <TrendingUp />,
              label: t('common.kpi-tracker'),
              route: 'kpi-tracker',
              component: <KpiEvaluationsPage />,
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
              subRoutes: ['setup/kpi-tracker'],
              subComponents: [<KpiTrackerSetupPage />],
            }, 
            {
              icon: <Category />,
              label: t('common.domains'),
              route: 'domains',
              component: <DomainsPage />,
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
            }, 
            {
              icon: <ListAlt />,
              label: t('common.clusters'),
              route: 'clusters',
              component: <ClustersPage />,
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
            }, 
            {
              icon: <FlagCircle />,
              label: t('common.standards'),
              route: 'standards',
              component: <GoalsPage />,
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
            }, 
            {
              icon: <Grade />,
              label: t('common.benchmarks'),
              route: 'benchmarks',
              component: <BenchmarksPage />,
              subRoutes: ['benchmarks/delete/:id', 'benchmarks/view/:id', 'benchmarks/edit/:id', 'benchmarks/add'],
              subComponents: [
                <BenchmarkCrudPage />,
                <BenchmarkCrudPage />,
                <BenchmarkCrudPage />,
                <BenchmarkCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'] as RoleType[],
            },

          ]
        }

export const navigationModel = (role: string = "") => {
  let items:INavItem[] = []

  switch(role) {
    case "teacher": {
      items = [
        {
          icon: <DesignServices />,
          label: t('common.my-workspace'),
          route: 'teacher-workspace',
          roles: ['teacher'],
          component: <TeacherWorkspacePage />,
        },
        {
          icon: <CastForEducation />,
          label: t('common.dashboard'),
          route: 'dashboard',
          roles: ['teacher'],
          component: <DashboardPage />,
        },
        {
          icon: <PendingActions />,
          label: t('common.my-courses'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            {
              icon: <AssignmentTurnedIn />,
              label: t('common.add-course'),
              route: 'course/add',
              roles: ['teacher'],
              component: <CourseCrudPage />,
            },
            {
              icon: <Summarize />,
              label: t('common.all-courses'),
              route: 'courses',
              subRoutes: ['courses/delete/:id', 'courses/view/:id', 'courses/edit/:id', 'courses/add', 'setup/courses'],
              subComponents: [<CourseCrudPage />, <CourseCrudPage />, <CourseCrudPage />, <CourseCrudPage />, <CourseSetupPage />],
              roles: ['teacher'],
              component: <CoursesPage />,
            },
            {
              icon: <ViewModule />,
              label: t('common.curriculum-maps'),
              route: 'curriculum-map',
              subRoutes: ['units','units/delete/:id', 'units/view/:id', 'units/edit/:id', 'units/add', 'setup/curriculum-map'],
              subComponents: [<CurriculumUnitsPage />, <UnitCrudPage />, <UnitCrudPage />, <UnitCrudPage />, <UnitCrudPage />, <CurriculumMapSetupPage />],
              roles: ['teacher'],
              component: <CurriculumMapsPage />,
            },
            {
              icon: <EventNote />,
              label: t('common.syllabus'),
              route: 'syllabus',
              subRoutes: ['syllabus/delete/:id', 'syllabus/view/:id', 'syllabus/edit/:id', 'syllabus/add', 'setup/syllabus'],
              subComponents: [<SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusSetupPage />],
              roles: ['teacher'],
              component: <SyllabusPage />,
            }, 
            {
              icon: <TableView />,
              label: t('common.rubrics'),
              route: 'rubrics',
              subRoutes: ['rubrics/delete/:id', 'rubrics/view/:id', 'rubrics/edit/:id', 'rubrics/add'],
              subComponents: [<RubricCrudPage />, <RubricCrudPage />, <RubricCrudPage />, <RubricCrudPage />],
              roles: ['teacher'],
              component: <RubricsPage />,
            },
          ]
        },
        {
          icon: <ReceiptLong />,
          label: t('common.my-lessons'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            {
              icon: <AssignmentTurnedIn />,
              label: t('common.add-lesson-plan'),
              route: 'lesson-plan/add',
              roles: ['teacher'],
              component: <LessonPlanCrudPage />,
            },
            {
              icon: <Schedule />,
              label: t('common.schedule-a-lesson'),
              route: 'teacher-classroom',
              roles: ['teacher'],
              component: <TeacherClassroomPage />,
            },
            {
              icon: <HowToReg />,
              label: t('common.attendance'),
              route: 'attendance',
              subRoutes: ['attendance/delete/:id', 'attendance/view/:id', 'attendance/edit/:id', 'attendance/add'],
              subComponents: [
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
              ],
              roles: ['teacher'],
              component: <TeacherAttendancePage />,
            },
            {
              icon: <Sports />,
              label: t('common.behaviour'),
              subRoutes: ['behaviour/delete/:id', 'behaviour/view/:id', 'behaviour/edit/:id', 'behaviour/add'],
              subComponents: [
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
              ],
              route: 'behaviour',
              roles: ['teacher'],
              component: <TeacherBehaviourPage />,
            },
            {
              icon: <ReceiptLong />,
              label: t('common.lesson-plans'),
              route: 'lesson-plans',
              subRoutes: ['lesson-plans/delete/:id', 'lesson-plans/view/:id', 'lesson-plans/edit/:id', 'lesson-plans/add'],
              subComponents: [<LessonPlanCrudPage />, <LessonPlanCrudPage />, <LessonPlanCrudPage />, <LessonPlanCrudPage />],
              roles: ['teacher'],
              component: <LessonPlansPage />,
            },
          ]
        },
        {
          icon: <Assignment />,
          label: t('common.assignments'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            {
              icon: <AssignmentTurnedIn />,
              label: t('common.add-assignment'),
              route: 'assignment/add',
              roles: ['teacher'],
              component: <AssignmentCrudPage />,
            },
            {
              icon: <Assignment />,
              label: t('common.all-assignments'),
              route: 'assignments',
              subRoutes: [
                'assignments/delete/:id',
                'assignments/view/:id',
                'assignments/edit/:id',
                'assignments/add',
              ],
              subComponents: [
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
              ],
              roles: ['teacher'],
              component: <AssignmentsPage />,
            }, 
            {
              icon: <UploadFile />,
              label: t('common.submissions'),
              route: 'submissions',
              subRoutes: ['submissions/view/:id'],
              subComponents: [<SubmissionPage/>],
              roles: ['teacher'],
              component: <SubmissionsPage />,
            },
            {
              icon: <Grading />,
              label: t('common.assessment-results'),
              route: 'assessments',
              roles: ['teacher'],
              component: <GradebookAssessmentsPage />,
            },
          ]
        },
        
        MCID,

        {
          icon: <Book />,
          label: t('common.gradebook-grid'),
          route: 'grades',
          subRoutes: ['course-components'],
          subComponents: [<CourseComponentsPage/>],
          roles: ['teacher'],
          component: <GradebookPage />,
        },
        {
          icon: <Difference />,
          label: t('school.grading-scale'),
          route: 'view-grade-scale',
          subRoutes: [
              'view-grade-scale/delete/:id',
              'view-grade-scale/view/:id',
              'view-grade-scale/edit/:id',
              'view-grade-scale/add',
          ],
          subComponents: [
            <GradeScaleCrudPage />,
            <GradeScaleCrudPage />,
            <GradeScaleCrudPage />,
            <GradeScaleCrudPage />,
          ],
          roles: ['teacher'],
          component: <GradeScalePage />,
        },

        /*
        {
          icon: <FlagCircle />,
          label: t('common.goalbank'),
          route: 'goalbank',
          roles: ['teacher',],
          component: <GoalbankPage />,
        },
        */

        {
          icon: <ChatBubble />,
          label: t('common.communication-collaboration'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            {
              icon: <MeetingRoom />,
              label: t('common.meetings'),
              route: 'meetings',
              subRoutes: ['meetings/delete/:id', 'meetings/view/:id', 'meetings/edit/:id', 'meetings/add'],
              subComponents: [<MeetingCrudPage />, <MeetingCrudPage />, <MeetingCrudPage />, <MeetingCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <MeetingsPage />,
            }, 
            {
              icon: <HistoryEdu />,
              label: t('meetings.meeting-reports'),
              route: 'meeting-reports',
              subRoutes: ['meeting-reports/view/:id',],
              subComponents: [<MeetingReportCrudPage />],
              roles: ['teacher'],
              component: <MeetingReportsPage />,
            },
            {
              icon: <Campaign />,
              label: t('common.announcements'),
              route: 'announcements',
              subRoutes: [
                'announcements/delete/:id',
                'announcements/view/:id',
                'announcements/edit/:id',
                'announcements/add',
              ],
              subComponents: [
                <AnnouncementCrudPage />,
                <AnnouncementCrudPage />,
                <AnnouncementCrudPage />,
                <AnnouncementCrudPage />,
              ],
              roles: [
                'principal',
                'vice_principal',
                'staff_administrator',
                'teacher',
                'special_teacher',
                'nurse',
                'auditor',
                'student',
                'parent',
              ],
              component: <AnnouncementsPage />,
            },
          ]
        },

        {
          icon: <QueryStats />,
          label: t('common.reports'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            {
              icon: <Flag />,
              label: t('common.early-warnings'),
              route: 'early-warnings',
              roles: ['teacher',],
              component: <EarlyWarningsPage />,
            },
            {
              icon: <Insights />,
              label: t('common.plop-reports'),
              route: 'plop-report-records',
              subRoutes: ['plop-report-records/view/:id',],
              subComponents: [<PlopReportRecordCrudPage />],
              roles: ['teacher'],
              component: <PlopReportRecordsPage />,
            },
            {
              icon: <HowToReg />,
              label: t('common.attendance-reports'),
              route: 'attendance-reports',
              subRoutes: ['attendance-reports/view/:id'],
              subComponents: [ <AttendanceCrudPage report={true} /> ],
              roles: ['teacher',],
              component: <AttendancePage />,
            },
            {
              icon: <Sports />,
              label: t('common.behaviour-reports'),
              route: 'behaviour-reports',
              subRoutes: ['behaviour-reports/view/:id'],
              subComponents: [<BehaviorCrudPage report={true} /> ],
              roles: ['teacher',],
              component: <BehaviorPage />,
            },
          ]
        },
        {
          icon: <AdminPanelSettings />,
          label: t('common.rti'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: null,
          children: [
            {
              icon: <NotificationImportant />,
              label: t('common.rti-announcements'),
              route: 'rti-students',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiAnnouncementsPage />,
              subRoutes: ['rti-students/:id'],
              subComponents: [
                <RtiStudentPage />,
              ],
            },
            {
              icon: <CrisisAlert />,
              label: t('rti.identfiying-academic-risk'),
              route: 'rti-risks',
              subRoutes: ['rti-risks/delete/:id', 'rti-risks/view/:id', 'rti-risks/edit/:id', 'rti-risks/add'],
              subComponents: [
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiRisksPage />,
            },
            {
              icon: <FactCheck />,
              label: t('common.concern-reasons'),
              route: 'rti-concerns',
              subRoutes: ['rti-concerns/delete/:id', 'rti-concerns/view/:id', 'rti-concerns/edit/:id', 'rti-concerns/add'],
              subComponents: [
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiConcernsPage />,
            },
            {
              icon: <Insights />,
              label: t('common.present-level-of-performance'),
              route: 'plop-reports',
              subRoutes: ['plop-reports/delete/:id', 'plop-reports/view/:id', 'plop-reports/edit/:id', 'plop-reports/add'],
              subComponents: [
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <PlopReportsPage />,
            },
            {
              icon: <PublishedWithChanges />,
              label: t('common.accommodations-and-modifications'),
              route: 'adjustments',
              subRoutes: ['adjustments/delete/:id', 'adjustments/view/:id', 'adjustments/edit/:id', 'adjustments/add'],
              subComponents: [
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <AdjustmentsPage />,
            },
            {
              icon: <PersonSearch />,
              label: t('common.rti-interventions'),
              route: 'rti-interventions',
              subRoutes: ['rti-risks/delete/:id', 'rti-interventions/view/:id', 'rti-interventions/edit/:id', 'rti-interventions/add'],
              subComponents: [
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiInterventionsPage />,
            },
            {
              icon: <MeetingRoom />,
              label: t('common.rti-meetings'),
              route: 'rti-meetings',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor',],
              component: <RtiMeetingsPage />,
            },
            {
              icon: <SwitchAccount />,
              label: t('common.rti-team'),
              route: 'rti-team',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiTeamPage />,
            },
            {
              icon: <Group/>,
              label: t('common.teams'),
              route: 'teams',
              subRoutes: [
                'teams/delete/:id',
                'teams/view/:id',
                'teams/edit/:id',
                'teams/add',
              ],
              subComponents: [
                <TeamCrudPage />,
                <TeamCrudPage />,
                <TeamCrudPage />,
                <TeamCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher'],
              component: <TeamsPage />,
            },
          ]
        },
        {
          icon: <AccountBalance />,
          label: t('common.administration'),
          route: null,
          roles: ['teacher'],
          component: null,
          children: [
            
            {
              icon: <Groups />,
              label: t('common.groups'),
              route: 'groups',
              subRoutes: ['groups/delete/:id', 'groups/view/:id', 'groups/edit/:id', 'groups/add'],
              subComponents: [<GroupCrudPage />, <GroupCrudPage />, <GroupCrudPage />, <GroupCrudPage />],
              roles: ['teacher'],
              component: <GroupsPage />,
            },
            {
              icon: <EventNote />,
              label: t('common.group-schedule'),
              route: 'timetables',
              subRoutes: ['timetables/delete/:id', 'timetables/view/:id', 'timetables/edit/:id', 'timetables/add'],
              subComponents: [
                <TimetableCrudPage />,
                <TimetableCrudPage />,
                <TimetableCrudPage />,
                <TimetableCrudPage />,
              ],
              roles: ['teacher'],
              component: <TimetablesPage />,
            },
            {
              icon: <LockClock/>,
              label: t('common.group-courses'),
              route: 'group-courses',
              subRoutes: [
                'group-courses/delete/:id',
                'group-courses/view/:id',
                'group-courses/edit/:id',
                'group-courses/add',
              ],
              subComponents: [
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
              ],
              roles: ['teacher'],
              component: <GroupCoursesPage />,
            },
            {
              icon: <School />,
              label: t('common.students'),
              route: 'students',
              subRoutes: ['students/delete/:id', 'students/view/:id', 'students/edit/:id', 'students/add'],
              subComponents: [<StudentCrudPage />, <StudentCrudPage />, <StudentCrudPage />, <StudentCrudPage />],
              roles: ['teacher'],
              component: <StudentsPage />,
            },
            {
              icon: <SupervisedUserCircle />,
              label: t('common.parents'),
              route: 'parents',
              subRoutes: ['parents/delete/:id', 'parents/view/:id', 'parents/edit/:id', 'parents/add'],
              subComponents: [<ParentCrudPage />, <ParentCrudPage />, <ParentCrudPage />, <ParentCrudPage />],
              roles: ['teacher'],
              component: <ParentsPage />,
            },
            {
              icon: <FaChalkboardTeacher />,
              label: t('common.teachers'),
              route: 'teachers',
              subRoutes: ['teachers/delete/:id', 'teachers/view/:id', 'teachers/edit/:id', 'teachers/add'],
              subComponents: [<TeacherCrudPage />, <TeacherCrudPage />, <TeacherCrudPage />, <TeacherCrudPage />],
              roles: ['teacher'],
              component: <TeachersPage />,
            },
            {
              icon: <BadgeRounded />,
              label: t('common.staff'),
              route: 'staff',
              subRoutes: ['staff/delete/:id', 'staff/view/:id', 'staff/edit/:id', 'staff/add'],
              subComponents: [<StaffCrudPage />, <StaffCrudPage />, <StaffCrudPage />, <StaffCrudPage />],
              roles: ['teacher'],
              component: <StaffPage />,
            },
          ],
        }, 
        {
          icon: <Settings />,
          label: t('common.setup'),
          route: 'setup',
          roles: ['teacher'],
          component: <SetupPage />,
          subRoutes: [
            'setup/:type/list',
            'setup/:type/list/delete/:id',
            'setup/:type/list/view/:id',
            'setup/:type/list/edit/:id',
            'setup/:type/list/add',
            'setup/:type/setting'
          ],
          subComponents: [
            <SetupEntityPage />,
            <SetupEntityCrudPage />, 
            <SetupEntityCrudPage />,
            <SetupEntityCrudPage />,
            <SetupEntityCrudPage />,
            <SetupEntitySettingCrudPage />
          ],
        },

      ]
      break
    }
    default: {
      
      items = [
        {
          icon: <Home />,
          label: t('common.welcome'),
          route: 'home',
          roles: ['student'],
          component: <StudentWelcomePage />,
        },
        {
          icon: <DesignServices />,
          label: t('common.dashboard'),
          route: 'parent-workspace',
          roles: ['parent'],
          component: <ParentWorkspacePage />,
        },
        {
          icon: <DesignServices />,
          label: t('common.my-workspace'),
          route: 'student-workspace',
          roles: ['student'],
          component: <StudentWorkspacePage />,
        },
        {
          icon: <CastForEducation />,
          label: t('common.dashboard'),
          route: 'dashboard',
          roles: [
            'principal',
            'vice_principal',
            'staff_administrator',
            'teacher',
            'special_teacher',
            'nurse',
            'auditor',
          ],
          component: <DashboardPage />,
        },
        {
          icon: <Schedule />,
          label: t('common.sessions'),
          route: 'sessions',
          subRoutes: ['sessions/delete/:id', 'sessions/view/:id', 'sessions/edit/:id', 'sessions/add'],
          subComponents: [<SessionCrudPage />, <SessionCrudPage />, <SessionCrudPage />, <SessionCrudPage />],
          roles: ['principal', 'vice_principal', 'staff_administrator', 'special_teacher', 'nurse', 'auditor'],
          component: <SessionsPage />,
        },
        {
          icon: <CastForEducation />,
          label: t('common.dashboard'),
          route: 'student-dashboard',
          roles: ['student'],
          component: <StudentDashboardPage />,
        },
        {
          icon: <Assignment />,
          label: t('common.my-assignments'),
          route: 'student-assignments',
          subRoutes: [
            'student-assignments/delete/:id',
            'student-assignments/view/:id',
            'student-assignments/edit/:id',
            'student-assignments/add',
          ],
          subComponents: [
            <StudentAssignmentCrudPage />,
            <StudentAssignmentCrudPage />,
            <StudentAssignmentCrudPage />,
            <StudentAssignmentCrudPage />,
          ],
          roles: ['student'],
          component: <StudentAssignmentsPage />,
        },
        {
          icon: <PunchClock />,
          label: t('common.class-schedule'),
          route: 'class-schedule',
          roles: ['student','parent'],
          component: <StudentGroupsPage />,
        },
        {
          icon: <PendingActions />,
          label: t('common.curriculum'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: null,
          children: [

            {
              icon: <ViewModule />,
              label: t('common.curriculum-maps'),
              route: 'curriculum-map',
              subRoutes: ['units','units/delete/:id', 'units/view/:id', 'units/edit/:id', 'units/add', 'setup/curriculum-map'],
              subComponents: [<CurriculumUnitsPage />, <UnitCrudPage />, <UnitCrudPage />, <UnitCrudPage />, <UnitCrudPage />, <CurriculumMapSetupPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher'],
              component: <CurriculumMapsPage />,
            },



            /*
            { 
              icon: <ListAlt />,
              label: t('common.course-chapters'),
              route: 'course-chapters',
              subRoutes: [
                'course-chapters/delete/:id',
                'course-chapters/view/:id',
                'course-chapters/edit/:id',
                'course-chapters/add',
              ],
              subComponents: [
                <CourseChapterCrudPage />,
                <CourseChapterCrudPage />,
                <CourseChapterCrudPage />,
                <CourseChapterCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <CourseChaptersPage />,
            },
            */
              
            {
              icon: <Summarize />,
              label: t('common.course-planning'),
              route: 'courses',
              subRoutes: ['courses/delete/:id', 'courses/view/:id', 'courses/edit/:id', 'courses/add', 'setup/courses'],
              subComponents: [<CourseCrudPage />, <CourseCrudPage />, <CourseCrudPage />, <CourseCrudPage />, <CourseSetupPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'auditor'],
              component: <CoursesPage />,
            },
            {
              icon: <EventNote />,
              label: t('common.syllabus'),
              route: 'syllabus',
              subRoutes: ['syllabus/delete/:id', 'syllabus/view/:id', 'syllabus/edit/:id', 'syllabus/add', 'setup/syllabus'],
              subComponents: [<SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusCrudPage />, <SyllabusSetupPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'auditor'],
              component: <SyllabusPage />,
            }, 
            {
              icon: <ReceiptLong />,
              label: t('common.lesson-plans'),
              route: 'lesson-plans',
              subRoutes: ['lesson-plans/delete/:id', 'lesson-plans/view/:id', 'lesson-plans/edit/:id', 'lesson-plans/add'],
              subComponents: [<LessonPlanCrudPage />, <LessonPlanCrudPage />, <LessonPlanCrudPage />, <LessonPlanCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher'],
              component: <LessonPlansPage />,
            },
          ],
        },

        MCID,

        {
          icon: <MenuBook />,
          label: t('common.grades'),
          route: 'my-grades',
          roles: ['student'],
          component: <StudentGradesPage />,
        },
        {
          
          icon: <Book />,
          label: t('common.gradebook'),
          route: null,
          roles: [
            'principal',
            'vice_principal',
            'staff_administrator',
            'teacher',
            'special_teacher',
            'nurse',
            'auditor',
            'student',
          ],
          component: null,
          children: [
            {
              icon: <MenuBook />,
              label: t('common.grades'),
              route: 'recieved-grades',
              roles: ['parent'],
              component: <GradesPage />,
            },
            {
              icon: <Difference />,
              label: t('school.grading-scale'),
              route: 'view-grade-scale',
              roles: ['parent'],
              component: <GradeScalePage />,
            },
            {
              icon: <AssignmentTurnedIn />,
              label: t('common.assignments'),
              route: 'parent-assignments',
              roles: ['parent'],
              component: <StudentAssignmentsPage />,
            },
            {
              icon: <AssignmentTurnedIn />,
              label: t('common.add-assignment'),
              route: 'assignment/add',
              roles: ['principal', 'vice_principal', 'teacher'],
              component: <AssignmentCrudPage />,
            },
            {
              icon: <Assignment />,
              label: t('common.assignments'),
              route: 'assignments',
              subRoutes: [
                'assignments/delete/:id',
                'assignments/view/:id',
                'assignments/edit/:id',
                'assignments/add',
              ],
              subComponents: [
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
                <AssignmentCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <AssignmentsPage />,
            },
            {
              icon: <MenuBook />,
              label: t('common.gradebook-grid'),
              route: 'grades',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <GradebookPage />,
            },

            {
              icon: <HowToReg />,
              label: t('common.attendance'),
              route: 'attendance',
              subRoutes: ['attendance/delete/:id', 'attendance/view/:id', 'attendance/edit/:id', 'attendance/add'],
              subComponents: [
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
                <AttendanceCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <TeacherAttendancePage />,
            },
          
            {
              icon: <Sports />,
              label: t('common.behaviour'),
              subRoutes: ['behaviour/delete/:id', 'behaviour/view/:id', 'behaviour/edit/:id', 'behaviour/add'],
              subComponents: [
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
                <BehaviorCrudPage />,
              ],
              route: 'behaviour',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <TeacherBehaviourPage />,
            },
            {
              icon: <List />,
              label: t('common.course-components'),
              route: 'course-components',
              subRoutes: ['course-components/delete/:id', 'course-components/view/:id', 'course-components/edit/:id', 'course-components/add'],
              subComponents: [<CourseComponentCrudPage/>, <CourseComponentCrudPage/>, <CourseComponentCrudPage/>, <CourseComponentCrudPage/>],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <CourseComponentsPage />,
            },
            {
              icon: <UploadFile />,
              label: t('common.submissions'),
              route: 'submissions',
              subRoutes: ['submissions/view/:id'],
              subComponents: [<SubmissionPage/>],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
              component: <SubmissionsPage />,
            },
            {
              icon: <Grading />,
              label: t('common.assessments'),
              route: 'assessments',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <GradebookAssessmentsPage />,
            },

            {
              icon: <Difference />,
              label: t('school.grading-scale'),
              route: 'grade-scale',
              subRoutes: [
                'grade-scale/delete/:id',
                'grade-scale/view/:id',
                'grade-scale/edit/:id',
                'grade-scale/add',
              ],
              subComponents: [
                <GradeScaleCrudPage />,
                <GradeScaleCrudPage />,
                <GradeScaleCrudPage />,
                <GradeScaleCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher'],
              component: <GradeScalePage />,
            },
            {
              icon: <TableView />,
              label: t('common.rubrics'),
              route: 'rubrics',
              subRoutes: ['rubrics/delete/:id', 'rubrics/view/:id', 'rubrics/edit/:id', 'rubrics/add'],
              subComponents: [<RubricCrudPage />, <RubricCrudPage />, <RubricCrudPage />, <RubricCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher'],
              component: <RubricsPage />,
            },
          ],
        },


        {
          icon: <QueryStats />,
          label: t('common.reports'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
          component: null,
          children: [
            {
              icon: <Signpost />,
              label: t('common.personalized-learning-pathways'),
              route: 'parent-programs-page',
              component: <ParentProgramsPage />,
              roles: ['parent'] as RoleType[],
            }, 
            {
              icon: <Timer />,
              label: t('common.benchmark-tracker'),
              route: 'parent-benchmark-tracker',
              component: <BenchmarkEvaluationsPage />,
              roles: ['parent'] as RoleType[],
            }, 
            {
              icon: <TrendingUp />,
              label: t('common.kpi-tracker'),
              route: 'parent-kpi-tracker',
              component: <KpiEvaluationsPage />,
              roles: ['parent'] as RoleType[],
            }, 
            {
              icon: <Flag />,
              label: t('common.early-warnings'),
              route: 'early-warnings',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'parent', 'nurse', 'auditor'],
              component: <EarlyWarningsPage />,
            },
            {
              icon: <School />,
              label: t('risk.grade-risk-criteria'),
              route: 'grade-risk-criteria',
              subRoutes: [
                'grade-risk-criteria/delete/:id',
                'grade-risk-criteria/view/:id',
                'grade-risk-criteria/edit/:id',
                'grade-risk-criteria/add',
              ],
              subComponents: [
                <GradeRiskCriteriaCrudPage />,
                <GradeRiskCriteriaCrudPage />,
                <GradeRiskCriteriaCrudPage />,
                <GradeRiskCriteriaCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator'],
              component: <GradeRiskCriteriaPage />,
              skip: true,
            },
            {
              icon: <CrisisAlert />,
              label: t('risk.risk-criteria'),
              route: 'risk-criteria',
              roles: ['principal', 'vice_principal'],
              component: <RiskCriteriaPage />,
              skip: true,
            },
            {
              icon: <Insights />,
              label: t('common.plop-reports'),
              route: 'plop-report-records',
              subRoutes: ['plop-report-records/view/:id',],
              subComponents: [<PlopReportRecordCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
              component: <PlopReportRecordsPage />,
            },
            {
              icon: <HowToReg />,
              label: t('common.attendance-reports'),
              route: 'attendance-reports',
              subRoutes: ['attendance-reports/view/:id'],
              subComponents: [ <AttendanceCrudPage report={true} /> ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
              component: <AttendancePage />,
            },
            {
              icon: <Sports />,
              label: t('common.behaviour-reports'),
              route: 'behaviour-reports',
              subRoutes: ['behaviour-reports/view/:id'],
              subComponents: [<BehaviorCrudPage report={true} /> ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
              component: <BehaviorPage />,
            },
            {
              icon: <HistoryEdu />,
              label: t('meetings.meeting-reports'),
              route: 'meeting-reports',
              subRoutes: ['meeting-reports/view/:id',],
              subComponents: [<MeetingReportCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor', 'parent'],
              component: <MeetingReportsPage />,
            },
            {
              icon: <MedicalServices />,
              label: t('common.medical-records'),
              route: 'medical',
              subRoutes: ['medical/delete/:id', 'medical/view/:id', 'medical/edit/:id', 'medical/add'],
              subComponents: [
                <MedicalRecordCrudPage />,
                <MedicalRecordCrudPage />,
                <MedicalRecordCrudPage />,
                <MedicalRecordCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'special_teacher', 'nurse', 'parent'],
              component: <MedicalRecordsPage />,
            },
            /*
            {
              icon: <Analytics />,
              label: t('common.insights'),
              route: 'reports',
              roles: [
                'principal',
                'vice_principal',
                'staff',
                'teacher',
                'special_teacher',
                'nurse',
                'auditor',
                'parent',
              ],
              component: null,
            },
            */
          
          ]
        },
        {
          icon: <AdminPanelSettings />,
          label: t('common.rti'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: null,
          children: [
            {
              icon: <NotificationImportant />,
              label: t('common.rti-announcements'),
              route: 'rti-students',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiAnnouncementsPage />,
              subRoutes: ['rti-students/:id'],
              subComponents: [
                <RtiStudentPage />,
              ],
            },
            {
              icon: <CrisisAlert />,
              label: t('rti.identfiying-academic-risk'),
              route: 'rti-risks',
              subRoutes: ['rti-risks/delete/:id', 'rti-risks/view/:id', 'rti-risks/edit/:id', 'rti-risks/add'],
              subComponents: [
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
                <RtiRiskCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiRisksPage />,
            },
            {
              icon: <FactCheck />,
              label: t('common.concern-reasons'),
              route: 'rti-concerns',
              subRoutes: ['rti-concerns/delete/:id', 'rti-concerns/view/:id', 'rti-concerns/edit/:id', 'rti-concerns/add'],
              subComponents: [
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
                <RtiConcernCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiConcernsPage />,
            },
            {
              icon: <Insights />,
              label: t('common.present-level-of-performance'),
              route: 'plop-reports',
              subRoutes: ['plop-reports/delete/:id', 'plop-reports/view/:id', 'plop-reports/edit/:id', 'plop-reports/add'],
              subComponents: [
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
                <PlopReportCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <PlopReportsPage />,
            },
            {
              icon: <Signpost />,
              label: t('common.personalized-learning-pathways'),
              route: 'personalized-learning-pathways',
              roles: ['principal', 'vice_principal', 'teacher', 'special_teacher'],
              component: <ProgramsPage />,
              subRoutes: ['setup/personalized-learning-pathways'],
              subComponents: [<ProgramsSetupPage />],
            },
            {
              icon: <PublishedWithChanges />,
              label: t('common.accommodations-and-modifications'),
              route: 'adjustments',
              subRoutes: ['adjustments/delete/:id', 'adjustments/view/:id', 'adjustments/edit/:id', 'adjustments/add'],
              subComponents: [
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
                <AdjustmentCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <AdjustmentsPage />,
            },
            {
              icon: <PersonSearch />,
              label: t('common.rti-interventions'),
              route: 'rti-interventions',
              subRoutes: ['rti-risks/delete/:id', 'rti-interventions/view/:id', 'rti-interventions/edit/:id', 'rti-interventions/add'],
              subComponents: [
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
                <RtiInterventionCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiInterventionsPage />,
            },
            {
              icon: <MeetingRoom />,
              label: t('common.rti-meetings'),
              route: 'rti-meetings',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor',],
              component: <RtiMeetingsPage />,
            },
            {
              icon: <SwitchAccount />,
              label: t('common.rti-team'),
              route: 'rti-team',
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <RtiTeamPage />,
            },
            {
              icon: <Group/>,
              label: t('common.teams'),
              route: 'teams',
              subRoutes: [
                'teams/delete/:id',
                'teams/view/:id',
                'teams/edit/:id',
                'teams/add',
              ],
              subComponents: [
                <TeamCrudPage />,
                <TeamCrudPage />,
                <TeamCrudPage />,
                <TeamCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher'],
              component: <TeamsPage />,
            },
          ]
        },
        {
          icon: <Star />,
          label: t('common.special-education'),
          route: null,
          roles: ['principal', 'vice_principal', 'special_teacher'],
          component: null,
          children: [
            {
              icon: <AdminPanelSettings  />,
              label: t('common.iep-students'),
              route: 'iep-students',
              roles: ['principal', 'vice_principal', 'special_teacher'],
              component: <SpecialStudentsPage />,
              subRoutes: ['iep-students/:id'],
              subComponents: [
                <SpecialStudentPage />,
              ],
            },
            {
              icon: <MeetingRoom />,
              label: t('common.iep-meetings'),
              route: 'iep-meetings',
              roles: ['principal', 'vice_principal', 'special_teacher'],
              component: <SpecialMeetingsPage />,
            },
            {
              icon: <SwitchAccount />,
              label: t('common.special-team'),
              route: 'special-education-team',
              roles: ['principal', 'vice_principal', 'special_teacher'],
              component: <SpecialTeamPage />,
            },
          ]

        },

        {
          icon: <ViewModule />,
          label: t('goalbank.lessons'),
          route: 'my-curriculum-map',
          roles: ['student', 'parent'],
          component: <CurriculumMapsPage />,
        },

        {
          icon: <EventNote />,
          label: t('common.syllabus'),
          route: 'student-syllabus',
          subRoutes: ['student-syllabus/view/:id', ],
          subComponents: [<SyllabusCrudPage />],
          roles: ['parent', 'student'],
          component: <SyllabusPage />,
        },
        {
          icon: <ManageAccounts />,
          label: t('common.accounts'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: null,
          children: [
            {
              icon: <BadgeRounded />,
              label: t('common.staff'),
              route: 'staff',
              subRoutes: ['staff/delete/:id', 'staff/view/:id', 'staff/edit/:id', 'staff/add'],
              subComponents: [<StaffCrudPage />, <StaffCrudPage />, <StaffCrudPage />, <StaffCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <StaffPage />,
            },
            {
              icon: <FaChalkboardTeacher />,
              label: t('common.teachers'),
              route: 'teachers',
              subRoutes: ['teachers/delete/:id', 'teachers/view/:id', 'teachers/edit/:id', 'teachers/add'],
              subComponents: [<TeacherCrudPage />, <TeacherCrudPage />, <TeacherCrudPage />, <TeacherCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <TeachersPage />,
            },
            {
              icon: <School />,
              label: t('common.students'),
              route: 'students',
              subRoutes: ['students/delete/:id', 'students/view/:id', 'students/edit/:id', 'students/add'],
              subComponents: [<StudentCrudPage />, <StudentCrudPage />, <StudentCrudPage />, <StudentCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <StudentsPage />,
            },
            {
              icon: <SupervisedUserCircle />,
              label: t('common.parents'),
              route: 'parents',
              subRoutes: ['parents/delete/:id', 'parents/view/:id', 'parents/edit/:id', 'parents/add'],
              subComponents: [<ParentCrudPage />, <ParentCrudPage />, <ParentCrudPage />, <ParentCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator'],
              component: <ParentsPage />,
            },
          ],
        },
        {
          icon: <AccountBalance />,
          label: t('common.administration'),
          route: null,
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: null,
          children: [
            {
              icon: <FaSchool />,
              label: t('common.school-details'),
              route: 'school',
              subRoutes: ['grade-levels/delete/:id', 'grade-levels/view/:id', 'grade-levels/edit/:id', 'grade-levels/add'],
              subComponents: [<GradeLevelCrudPage />, <GradeLevelCrudPage />, <GradeLevelCrudPage />, <GradeLevelCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator'],
              component: <SchoolPage />,
            },
            {
              icon: <History />,
              label: t('school.academic-periods'),
              route: 'academic-periods',
              subRoutes: [
                'academic-periods/delete/:id',
                'academic-periods/view/:id',
                'academic-periods/edit/:id',
                'academic-periods/add',
              ],
              subComponents: [
                <AcademicPeriodCrudPage />,
                <AcademicPeriodCrudPage />,
                <AcademicPeriodCrudPage />,
                <AcademicPeriodCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator'],
              component: <AcademicPeriodsPage />,
            },
            {
              icon: <CalendarMonth />,
              label: t('school.academic-calendar'),
              route: 'milestones',
              subRoutes: ['milestones/delete/:id', 'milestones/view/:id', 'milestones/edit/:id', 'milestones/add'],
              subComponents: [
                <MilestoneCrudPage />,
                <MilestoneCrudPage />,
                <MilestoneCrudPage />,
                <MilestoneCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator'],
              component: <MilestonesPage />,
            },

            /*
            {
              icon: <Upgrade />,
              label: t('common.grade-levels'),
              route: 'grade-levels',
              subRoutes: ['grade-levels/delete/:id', 'grade-levels/view/:id', 'grade-levels/edit/:id', 'grade-levels/add'],
              subComponents: [<GradeLevelCrudPage />, <GradeLevelCrudPage />, <GradeLevelCrudPage />, <GradeLevelCrudPage />],
              roles: ['principal', 'vice_principal'],
              component: <GradeLevelsPage />,
            },
            */
            
            {
              icon: <Groups />,
              label: t('common.groups'),
              route: 'groups',
              subRoutes: ['groups/delete/:id', 'groups/view/:id', 'groups/edit/:id', 'groups/add'],
              subComponents: [<GroupCrudPage />, <GroupCrudPage />, <GroupCrudPage />, <GroupCrudPage />],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <GroupsPage />,
            },
            {
              icon: <EventNote />,
              label: t('common.group-schedule'),
              route: 'timetables',
              subRoutes: ['timetables/delete/:id', 'timetables/view/:id', 'timetables/edit/:id', 'timetables/add'],
              subComponents: [
                <TimetableCrudPage />,
                <TimetableCrudPage />,
                <TimetableCrudPage />,
                <TimetableCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher'],
              component: <TimetablesPage />,
            },
            {
              icon: <LockClock/>,
              label: t('common.group-courses'),
              route: 'group-courses',
              subRoutes: [
                'group-courses/delete/:id',
                'group-courses/view/:id',
                'group-courses/edit/:id',
                'group-courses/add',
              ],
              subComponents: [
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
                <GroupCourseCrudPage />,
              ],
              roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
              component: <GroupCoursesPage />,
            },
          ],
        },

        {
          icon: <MeetingRoom />,
          label: t('common.meetings'),
          route: 'meetings',
          subRoutes: ['meetings/delete/:id', 'meetings/view/:id', 'meetings/edit/:id', 'meetings/add'],
          subComponents: [<MeetingCrudPage />, <MeetingCrudPage />, <MeetingCrudPage />, <MeetingCrudPage />],
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse', 'auditor'],
          component: <MeetingsPage />,
        }, 
        {
          icon: <Campaign />,
          label: t('common.announcements'),
          route: 'announcements',
          subRoutes: [
            'announcements/delete/:id',
            'announcements/view/:id',
            'announcements/edit/:id',
            'announcements/add',
          ],
          subComponents: [
            <AnnouncementCrudPage />,
            <AnnouncementCrudPage />,
            <AnnouncementCrudPage />,
            <AnnouncementCrudPage />,
          ],
          roles: [
            'principal',
            'vice_principal',
            'staff_administrator',
            'teacher',
            'special_teacher',
            'nurse',
            'auditor',
            'student',
            'parent',
          ],
          component: <AnnouncementsPage />,
        },
        {
          icon: <Settings />,
          label: t('common.setup'),
          route: 'setup',
          roles: ['principal', 'vice_principal', 'staff_administrator', 'teacher', 'special_teacher', 'nurse'],
          component: <SetupPage />,
          subRoutes: [
            'setup/:type/list',
            'setup/:type/list/delete/:id',
            'setup/:type/list/view/:id',
            'setup/:type/list/edit/:id',
            'setup/:type/list/add',
            'setup/:type/setting'
          ],
          subComponents: [
            <SetupEntityPage />,
            <SetupEntityCrudPage />, 
            <SetupEntityCrudPage />,
            <SetupEntityCrudPage />,
            <SetupEntityCrudPage />,
            <SetupEntitySettingCrudPage />
          ],
        },
        {
          icon: null,
          label: `${t('errors.access-denied')}`,
          route: 'unauthorized',
          roles: [
            'principal',
            'vice_principal',
            'staff_administrator',
            'teacher',
            'special_teacher',
            'nurse',
            'auditor',
            'student',
            'parent',
          ],
          component: <UnauthorizedPage />,
          skip: true,
        },
      ]

    }
  }

  return items
}
